var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-more-wrapper"},[_c('router-link',{staticClass:"more",attrs:{"to":{ path: _vm.url },"active-class":"active"}},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('hr')],1)}
var staticRenderFns = []

export { render, staticRenderFns }